(ns frontend.view.nev.kyc.process-status-views.rejected-status
  (:require [frontend.view.nev.kyc.process-status-views.edit-view :as edit-view]
            [frontend.state.current-session :as session]
            [frontend.view.entity-viewers.modules.attachments :as attachments]
            [frontend.view.nev.kyc.process-status-views.view-utils :as kvu]))

(defn view [state-atom entity save!]
  [edit-view/view {:state-atom      state-atom
                   :save!           save!
                   :entity          entity
                   :mandatory?      true
                   :read-only?      true
                   :lang            :en
                   :footer-renderer (fn [state-atom answers-atom entity]
                                      (let [entity-id (:db/id entity)
                                            attachments (->> entity
                                                             :common/attachments
                                                             (filter (fn [attachment-id]
                                                                       (or (= attachment-id (:kyc-process/signed-document entity))
                                                                           ;; template documents??
                                                                           )))
                                                             (map session/get-entity))]
                                        [:div.d-flex.flex-static.flex-1.flex-column.kyc-submit-footer
                                         [:div
                                          {:class-name "container"}
                                          [:div
                                           {:class-name "grid grid-cols-10 gap-4 px-4"}
                                           [:div
                                            {:class-name "col-span-10"}
                                            [:div.attachment-list.px-0.pb-3
                                             (doall
                                              (for [attachment attachments]
                                                ^{:key (str "attachment-" entity-id "-" (or (:db/id attachment)
                                                                                            attachment))}
                                                [attachments/attachment-view {:attachment   attachment
                                                                              :hide-delete? true
                                                                              :target-id    entity-id}]))]]
                                           [:div
                                            {:class-name "col-span-4"}
                                            [kvu/exit-button entity :en]]
                                           [:div
                                            {:class-name "col-span-6"}
                                            [:div.d-flex.justify-content-end]]]]]))}])

